export default __webpack_public_path__ + "static/media/TH.72189ecc.ico";